module.exports = __webpack_public_path__ + "static/media/arrow-up-button.1f6d348e.png";